import { MenuEntry } from '@ape.swap/uikit'
import { ContextApi } from 'contexts/Localization/types'

const iframeConfig: (t: ContextApi['t']) => MenuEntry[] = () => []

export default iframeConfig
